import { FtBtnBox, SurveyAudioItemBox } from "style/inspect";
import InspectAudioItemBox from "../items/inspect.audio.item.box";

interface DataProps {
  question: string;
  audioPath_default: string;
  audioPath?: string[];
  handleAnswerSelect: (value: number) => void;
  handleNext: () => void;
  index: number;
}

const InspectSurveyAudioItem = ({
  audioPath,
  audioPath_default,
  handleAnswerSelect,
  index,
  question,
  handleNext,
}: DataProps) => {
  return (
    <SurveyAudioItemBox>
      <div className="index-box">
        <span>{index}</span>
        <span>/</span>
        <span>7</span>
      </div>
      <div className="m">
        <div className="question-box">
          <p className="question">{question}</p>
        </div>
        <div className="audio-box">
          <InspectAudioItemBox audioPath={audioPath_default} />
          <span>[기준음]</span>
        </div>
      </div>
      {audioPath && (
        <div className="survey-audio-box">
          {audioPath.map((item, index) => (
            <div className="box-item" key={"audio" + index}>
              <InspectAudioItemBox audioPath={item} />
              <button
                type="button"
                onClick={() => {
                  handleAnswerSelect(index);
                }}
              >
                선택
              </button>
            </div>
          ))}
        </div>
      )}
      {index === 1 && (
        <FtBtnBox>
          <button onClick={handleNext}>다음</button>
        </FtBtnBox>
      )}
    </SurveyAudioItemBox>
  );
};

export default InspectSurveyAudioItem;
